interface CollapseRow {
  label: string
  value: React.ReactNode
}

interface CollapseRowProps {
  rows: CollapseRow[]
}

export const CollapseRow = ({ rows }: CollapseRowProps) => {
  return (
    <div className="flex flex-col text-sm">
      {rows.map((row, i) => (
        <div
          key={i}
          className="grid grid-cols-[180px_1fr] border-t border-[#E2E8F0]"
          style={{ minHeight: "64px" }}
        >
          <div className="bg-[#F8FAFC] px-4 py-3 flex items-center font-medium">
            <span className="text-sm text-[#62748E]">{row.label}</span>
          </div>
          <div className="px-4 py-4 flex items-center">
            <span className="text-sm text-[#020618]">{row.value}</span>
          </div>
        </div>
      ))}
    </div>
  )
}
